<template>
  <section class="quotewizard">
    <div class="container">
      <br /><br />
      <div class="fieldleft">
        {{ quote.address.firstName }} {{ quote.address.lastName }}<br />
        <p>
          {{ quote.address.address }}<br />
          {{ quote.address.city }}, {{ quote.address.state.short }}
          {{ quote.address.zip }}
        </p>
      </div>
      <div style="clear: both"></div>
      <div class="textheader">Notice of Adverse Underwriting Decision</div>
      <p class="responsemessage">{{ quote.responseMessage }}</p>
      <!-- <div v-html="safeDenailNotice"></div> -->
      <div v-html="quote.denialNotice"></div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { onMounted, computed } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import { scrollTop } from "@/utils/Utils";
//import DOMPurify from "dompurify";

const title = "Notice of adverse";
const quote = useQuoteStore();
//const safeDenailNotice = DOMPurify.sanitize(quote.denialNotice);

onMounted(() => {
  scrollTop();
  quote.done = true;
});

const date = computed(() => {
  const today = new Date();
  return today.toLocaleDateString();
});
</script>
